export const RE_SORT = 'ops.columns.sorting.re-sort.RE_SORT' as const;

export type ReSortAction = {
	type: typeof RE_SORT;
};

export const reSort = (): ReSortAction => ({
	type: RE_SORT,
});
